import React, { useEffect, useState } from 'react';

import Presenter from 'components/presenters/campaign/CampaignInfoTab';

export default function CampaignInfoTab({isShowReward, currTab, onChangeTab, onCurrTabScrollTrigger }) {
  const [activeTab, setActiveTab] = useState(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if(onCurrTabScrollTrigger)
    {
      onCurrTabScrollTrigger(tab);
    }
  }

  useEffect(() => {
    setActiveTab(currTab);
  }, [currTab])

  useEffect(() => {
    if(isShowReward)
    {
      setActiveTab('reward');
    }
    else
    {
      setActiveTab('todolist');
    }
  }, [isShowReward])

  return (
    <Presenter 
      activeTab={activeTab} 
      isShowReward={isShowReward}
      onTabClick={handleTabClick}
    />
  )
}